import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {CourseSection} from '../models/course-section.model';


export const addCourseSection = createAction(
  '[CourseSection] Add Course Section',
  props<{ courseSection: CourseSection }>()
);

export const courseSectionsLoaded = createAction(
  '[Course Effects] Course Sections Loaded',
  props<{ courseSections: CourseSection[], courseId:string }>()
);

export const updateCourseSection = createAction(
  '[CourseSection] Update Course Section',
  props<{ courseSection: Update<CourseSection> }>()
);

export const deleteCourseSection = createAction(
  '[CourseSection] Delete Course Section',
  props<{ id: string }>()
);

export const updateSectionOrder = createAction(
  '[Edit Lessons Screen] Updated Section Order',
  props<{courseId:string, newSortOrder: CourseSection[]}>()
);


export const updateSectionOrderCompleted = createAction(
  '[Edit Lessons Screen] Updated Section Order Completed'
);

export const loadCourseSectionsPage = createAction(
  '[Course Section] Load Course Sections Page',
  // pageSize is how many sections to add per request. It defaults to 1 because the course
  // PLAYER relies on advancing exactly one section at a time - it auto-navigates the student to
  // the section matching lastSeqNoLoaded, so loading a batch there would skip them forward.
  // The sales page has no such constraint and asks for a larger batch.
  props<{ courseId: string, afterSeqNo: number, pageSize?: number }>()
);

export const loadCourseSectionsBefore = createAction(
  '[Course Section] Load Course Sections Before',
  props<{ courseId: string, beforeSeqNo: number }>()
);

export const courseSectionPageLoaded = createAction(
  '[Course Effects] Course Section Page Loaded',
  props<{ courseSections: CourseSection[], courseId: string, allLoaded: boolean, direction: 'next' | 'prev' | 'initial' | 'landing' }>()
);

export const courseSectionPageLoadFailed = createAction(
  '[Course Effects] Course Section Page Load Failed',
  props<{ direction: 'next' | 'prev' }>()
);



